export const fieldSx = {
  margin: 0,
  width: "100%",
  "& .MuiOutlinedInput-root": {
    color: "#fafafa",
    minHeight: 40,
    alignItems: "center",
    "& fieldset": { borderColor: "#52525b" },
    "&:hover fieldset": { borderColor: "#a1a1aa" },
    "&.Mui-focused fieldset": { borderColor: "#818cf8" },
  },
  "& .MuiOutlinedInput-input": {
    py: 1,
    fontSize: "0.875rem",
  },
  "& .MuiInputLabel-root": { color: "#a1a1aa", fontSize: "0.875rem" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#a5b4fc" },
  "& .MuiSelect-icon": { color: "#a1a1aa" },
  "& .MuiFormHelperText-root": { color: "#71717a", mx: 0 },
} as const;

export const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: "#0a0a0a",
      border: "1px solid #27272a",
      "& .MuiMenuItem-root": { color: "#fafafa" },
      "& .MuiMenuItem-root:hover": { bgcolor: "#27272a" },
      "& .Mui-selected": { bgcolor: "#27272a" },
    },
  },
} as const;

export const cardSx = {
  p: 2,
  border: "1px solid #27272a",
  borderRadius: 1,
  bgcolor: "#18181b",
} as const;

export function errorText(err: unknown, fallback: string): string {
  const data = (err as { data?: unknown })?.data;
  if (typeof data === "string" && data.trim()) return data.trim();
  if (data && typeof data === "object") {
    const values = Object.values(data as Record<string, unknown>);
    const first = values.find((value) => typeof value === "string" && value.trim());
    if (typeof first === "string") return first;
  }
  return fallback;
}
